<template>
  <div class="cashier-state-screen">
    <div class="cashier-state-shell">
      <div class="cashier-state-card cashier-state-card--error cashier-state-card--compact">
        <div class="cashier-state-mark">
          <img src="../assets/icon/error.svg" alt="错误" />
        </div>
        <div class="cashier-state-eyebrow">支付异常</div>
        <h1 class="cashier-state-title">当前无法继续支付</h1>
        <div class="cashier-state-message">错误：{{ msg }}</div>
      </div>
    </div>
  </div>
</template>

<script>

// 分发器页面，  用户扫码后进入的第一个页面：
// 判断是否存在channelUserId, 如果存在则直接跳到 对应的支付页面，如果不存在则重定向到对应的页面。
export default {
  data () {
    return {
        msg: "请重新扫码进入！",
    }
  },
  components: {

  },
  mounted() {
    this.msg = this.$route.params.errInfo || '请重新扫码进入！'
  }
}
</script>
<style lang="css" scoped>
@import './cashier-desktop.css';
</style>
